const m = require("air-vue-model")();
m.url = "tickets";
m.name = "tickets";

module.exports = m;
